import { render, staticRenderFns } from "./RespuestaError.vue?vue&type=template&id=2b160a63&scoped=true"
import script from "./RespuestaError.vue?vue&type=script&lang=js"
export * from "./RespuestaError.vue?vue&type=script&lang=js"
import style0 from "./RespuestaError.vue?vue&type=style&index=0&id=2b160a63&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b160a63",
  null
  
)

export default component.exports